import Modal from '@components/v2/ui/Modal/Modal';
import Typography from '@components/v2/ui/Typography/Typography';
import type { ReactNode } from 'react';
import LangEnum from '../../../../lang/LangEnum';
import { Team } from '../../../context/ApplicationContext/applicationContext.types';
import { useTranslation } from '../../../translation/TranslationContext';
import SelectModalList from '../SelectModalList/SelectModalList';
import { SELECT_MODAL_HEIGHT } from '../SelectModalList/selectModalList.constants';
import useTeamSelectModal from './hooks/useTeamSelectModal';

type TeamSelectModalProps = {
  teams: Array<Team>;
  title: LangEnum | ReactNode;
  open: boolean;
  onClose: () => void;
  onClick?: (team: Team) => void;
  onBack?: () => void;
  isLoading?: boolean;
  headerTextKey?: LangEnum;
};

const TeamSelectModal = ({
  teams,
  title,
  open,
  onClose,
  onClick,
  onBack,
  isLoading = false,
  headerTextKey = LangEnum.TEAM_MODAL_CHOOSE_TEAM_TEXT,
}: TeamSelectModalProps) => {
  const { translate } = useTranslation();
  const { items } = useTeamSelectModal({ teams, onClose, onClick });

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      size="compact"
      height={SELECT_MODAL_HEIGHT}
      header={{ title }}
      footer={
        onBack ? { secondaryAction: { label: LangEnum.GLOBAL_BACK, onClick: onBack } } : undefined
      }
      slots={{
        headerBottom: (
          <Typography variant="body2" color="text.secondary">
            {translate(headerTextKey)}
          </Typography>
        ),
      }}
    >
      <SelectModalList
        items={items}
        isLoading={isLoading}
        emptyMessage={LangEnum.TEAM_MODAL_NO_TEAM}
      />
    </Modal>
  );
};

export default TeamSelectModal;
